<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      :title="title"
      direction="rtl"
      :size="853"
      :before-close="handleClose"
      @close="close()"
      append-to-body
      :close-on-press-escape="false"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :evgPlanOrderCode="evgPlanOrderCode"
          :evgPlanOrderWhCode="evgPlanOrderWhCode"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
          style="width: 100px; height: 30px"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    evgPlanOrderCode: { type: String, default: '' },
    evgPlanOrderWhCode: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return ['detail', 'confirm'].includes(this.type)
    },
    titleMap() {
      return {
        add: this.$l('dialog_title_add') || '新增客户计划',
        edit: this.$l('dialog_title_edit') || '编辑客户计划',
      }
    },
    title() {
      return this.titleMap[this.type] || ''
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('reload')
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 0px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
